import React from 'react';
import PropTypes from 'prop-types';
import { intlShape } from '../../../util/reactIntl';
import css from './Sections.module.css';
import bannerImg from '../../../assets/how-it-works.png';
import bannerImgMobile from '../../../assets/how-it-works-mobile.png';

import { Heading, PrimaryButton, SecondaryButton } from '../../../components';
import routeConfiguration from '../../../routing/routeConfiguration';
import { createResourceLocatorString } from '../../../util/routes';

function SectionHero(props) {
  const { intl, viewport, history } = props;
  const isMobileLayout = viewport?.width > 0 && viewport?.width < 768;
  return (
    <div className={css.heroContainer}>
      <div className={css.fixedWidthContainer}>
        <div className={css.heroContentWrapper}>
          <div
            className={css.heroContentWrapperInner}
            style={{
              backgroundImage: `url(${isMobileLayout ? bannerImgMobile : bannerImg})`,
              height: '100%',
            }}
          >
            <div className={css.heroContent}>
              <Heading as="h1" rootClassName={css.heading}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionHero.titlePart1' })} <br /> 
                <strong>{intl.formatMessage({ id: 'HowItWorksPage.SectionHero.titlePart2' })}</strong>
                <span>{intl.formatMessage({ id: 'HowItWorksPage.SectionHero.titlePart3' })}</span>
              </Heading>
              <p className={css.para}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionHero.description1' })}
              </p>
              <p className={css.para}>
                {intl.formatMessage({ id: 'HowItWorksPage.SectionHero.description2' })}
              </p>
              <p className={css.para}>{intl.formatMessage({ id: 'HowItWorksPage.SectionHero.description3' })}</p>
              <div className={css.heroBtns}>
                <SecondaryButton 
                  className={css.sellBtn} 
                  type="button"
                  onClick={() => history.push(createResourceLocatorString('NewListingPage', routeConfiguration(), {}, {}))}
                >
                  {intl.formatMessage({ id: 'HowItWorksPage.SectionHero.startSelling' })}
                </SecondaryButton>
                <SecondaryButton 
                  className={css.browseBtn} 
                  type="button"
                  onClick={() => history.push(createResourceLocatorString('SearchPage', routeConfiguration(), {}, {}))}
                >
                  {intl.formatMessage({ id: 'HowItWorksPage.SectionHero.startBrowsing' })}
                </SecondaryButton>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

SectionHero.propTypes = {
  intl: intlShape.isRequired,
};

export default SectionHero;